import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'contrastColor',
  standalone: true,
})
export class ContrastColorPipe implements PipeTransform {
  transform(bgColor: string | null | undefined): 'white' | 'black' {
    if (!bgColor) return 'black';

    const hex = bgColor.replace('#', '');

    // Suporte a hex de 3 ou 6 dígitos
    const fullHex =
      hex.length === 3
        ? hex
            .split('')
            .map((c) => c + c)
            .join('')
        : hex;

    const r = parseInt(fullHex.substring(0, 2), 16);
    const g = parseInt(fullHex.substring(2, 4), 16);
    const b = parseInt(fullHex.substring(4, 6), 16);

    // Luminância relativa (WCAG 2.1)
    const toLinear = (c: number) => {
      const s = c / 255;
      return s <= 0.04045 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
    };

    const luminance =
      0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b);

    // Contraste com branco e preto
    const contrastWithWhite = 1.05 / (luminance + 0.05);
    const contrastWithBlack = (luminance + 0.05) / 0.05;

    return contrastWithWhite >= contrastWithBlack ? 'white' : 'black';
  }
}
